import React from 'react';
import './UIUnit.scss';
import UIIconButton from '../UIIconButton/UIIconButton';
import UIProperty from '../UIProperty/UIProperty';
import UIMap from '../UIMap';
import { TenancyProperty } from '../UITenancyOverwiev/UITenancyOverwiev';

interface UIUnitProps {
  property: TenancyProperty;
}

const UIUnit: React.FC<UIUnitProps> = ({ property }) => {
  const geoData =
    property.latitude != null && property.longitude != null
      ? [
          {
            label: property.name,
            x: Number(property.longitude),
            y: Number(property.latitude),
            raw: {
              addresstype: 'building' as const,
              type: 'house' as const,
            },
          },
        ]
      : [];

  const renderActionButtons = (prop: TenancyProperty) => (
    <div className="UIUnit__buttons">
      <UIIconButton
        variant="info"
        iconType="info"
        onClick={() => prop.onPropertyInfo?.(prop.id)}
        title="Property Information"
      />
      <UIIconButton
        variant="success"
        iconType="contact"
        onClick={() => prop.onContactProperty?.(prop.id)}
        title="Contact Property"
      />
      {prop.hasDebt && (
        <UIIconButton
          variant="danger"
          iconType="warning"
          onClick={() => prop.onReportWarning?.(prop.id)}
          title="Report Issue"
        />
      )}
    </div>
  );

  return (
    <div className="UIUnit__info">
      <div className="UIUnit__map">
        <UIMap
          geoData={geoData}
          streetAddress={property.address}
        />
      </div>

      <div className="UIUnit__property-content">
        <UIProperty
          name={property.name}
          type={property.type}
          onClick={() => property.onPropertyInfo?.(property.id)}
        />

        <div className="UIUnit__table">
          <div className="UIUnit__field-names">
            <div className="UIUnit__field-name">
              Address:
            </div>
            <div className="UIUnit__field-name">Unit:</div>
          </div>
          <div className="UIUnit__field-infos">
            <div className="UIUnit__field-info">
              {property.address}
            </div>
            <div className="UIUnit__field-info">
              {property.unit}
            </div>
          </div>
        </div>

        {renderActionButtons(property)}
      </div>
    </div>
  );
};

export default UIUnit;
